<template>
  <el-dialog :visible.sync="visible" :title="dialogTitle" width="60%" @close="handleClose">
    <el-form :model="form" ref="form" label-width="100px">
      <el-form-item label="价格配置名称">
        <el-input v-model="form.name" :disabled="isView" placeholder="请输入价格配置名称"></el-input>
      </el-form-item>
      <el-table :data="form.list" style="width: 100%" border>
        <el-table-column label="涂料类型">
          <template slot-scope="scope">
            <el-select v-model="scope.row.paintType" placeholder="请选择涂料类型" :disabled="isView" filterable>
              <el-option v-for="item in availableTypes" :key="item" :label="item" :value="item" :disabled="selectedTypes.includes(item)"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="客户价格">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.customerPrice" :disabled="isView" :min="0" :precision="2"></el-input-number>
          </template>
        </el-table-column>
        <el-table-column label="装饰公司价格">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.decorationCompanyPrice" :disabled="isView" :min="0" :precision="2"></el-input-number>
          </template>
        </el-table-column>
        <el-table-column label="商户价格">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.merchantPrice" :disabled="isView" :min="0" :precision="2"></el-input-number>
          </template>
        </el-table-column>
        <!-- 工程师费用 -->
        <el-table-column label="工程师费用">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.engineerSingleFee" :disabled="isView" :min="0" :precision="2"></el-input-number>
          </template>
        </el-table-column>
        <el-table-column v-if="!isView">
          <template slot-scope="scope">
            <el-button type="text" icon="el-icon-minus" @click="handleRemove(scope.$index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-button v-if="!isView" type="text" icon="el-icon-plus" @click="handleAddItem" :disabled="form.list.length>=paintTypes.length" style="margin-top: 10px;">新增一行</el-button>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button v-if="!isView" type="primary" @click="handleConfirm">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      dialogType: 'add',
      form: {
        name: '',
        list: []
      },
      rules: {
        name: [
          { required: true, message: '请输入价格配置名称', trigger: 'blur' }
        ],
        list: [
          {
            paintType: { required: true, message: '请选择涂料类型', trigger: 'blur' },
            customerPrice: { required: true, message: '请输入客户价格', trigger: 'blur' },
            decorationCompanyPrice: { required: true, message: '请输入装饰公司价格', trigger: 'blur' },
            merchantPrice: { required: true, message: '请输入商户价格', trigger: 'blur' },
            engineerSingleFee: { required: true, message: '请输入工程师费用', trigger: 'blur' }
          }
        ]
      },
      paintTypes: ['蓝色', '橙色'],
      selectedTypes: []
    }
  },
  computed: {
    dialogTitle() {
      return this.dialogType === 'add' ? '新增价格配置' : this.dialogType === 'edit' ? '编辑价格配置' : '查看价格配置'
    },
    isView() {
      return this.dialogType === 'view'
    },
    availableTypes() {
      return this.paintTypes.filter(paintType => !this.form.list.some(item => item.paintType === paintType))
    }
  },
  methods: {
    open(paintType, data) {
      this.dialogType = paintType
      if (data) {
        this.form = JSON.parse(JSON.stringify(data))
        this.selectedTypes = this.form.list.map(item => item.paintType)
      } else {
        this.form = { name: '', list: [] }
        this.selectedTypes = []
      }
      this.visible = true
    },
    handleClose() {
      this.$refs.form.resetFields()
      this.form = { name: '', list: [] }
      this.selectedTypes = []
    },
    handleAddItem() {
      this.form.list.push({
        paintType: '',
        customerPrice: 0,
        decorationCompanyPrice: 0,
        merchantPrice: 0
      })
    },
    handleRemove(index) {
      this.form.list.splice(index, 1)
    },
    handleConfirm() {
      // 校验表单
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 校验表格数据
          let validTable = true
          this.form.list.forEach((item, index) => {
            if (!item.paintType || !item.customerPrice || !item.decorationCompanyPrice || !item.merchantPrice || !item.engineerSingleFee) {
              validTable = false
              this.$message.error(`表格第${index + 1}行数据不完整`)
            }
          })
          if (validTable) {
            this.submitForm()
          }
        } else {
          return false
        }
      })
    },
    submitForm() {
      this.$emit('confirm', this.form)
      this.visible = false
    }
  }
}
</script>